import { CustomerLayout } from "@/components/CustomerLayout/CustomerLayout";
import { DocumentSletting } from "@/components/DocumentSletting/DocumentSletting";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/sletting/$slettingId/")({
  loader: async ({ params }) => {
    const { tluxCaseId, slettingId } = params;

    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sletting[":slettingId"].$get({
      param: {
        tluxCaseId,
        slettingId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch sletting");
    }

    return {
      sletting: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Rediger sletting | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { tluxCaseId, slettingId } = Route.useParams();
  const { sletting } = Route.useLoaderData();

  return (
    <CustomerLayout>
      <DocumentSletting
        tluxCaseId={tluxCaseId}
        slettingId={slettingId}
        sletting={sletting}
        cancelUrl={`/oppdrag/${tluxCaseId}`}
      />
    </CustomerLayout>
  );
}
